module.exports = __webpack_public_path__ + "media/slots_arthurs_camelot_ambiance_witch.2f9155ba.mp3";